import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=b7c8f6bc&"
import script from "./Website.vue?vue&type=script&lang=ts&"
export * from "./Website.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports